import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <script src=\""
    + container.escapeExpression((lookupProperty(helpers,"mboxScript")||(depth0 && lookupProperty(depth0,"mboxScript"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"site"))) && lookupProperty(stack1,"isProd")),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"env")),{"name":"mboxScript","hash":{},"data":data,"loc":{"start":{"line":2,"column":15},"end":{"line":2,"column":59}}}))
    + "\"></script>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"ddo") : stack1)) != null ? lookupProperty(stack1,"load_adobetarget") : stack1),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":3,"column":11}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

function mboxScript(isProd, env) {
  try {
    const notprod = 'https://tags.tiqcdn.com/utag/bofa/main/notprod/utag.sync.js';
    const prod = 'https://tags.tiqcdn.com/utag/bofa/main/prod/utag.sync.js';

    // return prod if isProd = true or if isProd is undefined. Safety fallback if isProd isn't defined.
    if (isProd || env.toLowerCase().includes('prod')) {
      return prod;
    } else {
      return notprod;
    }
  } catch (e) {
    // return prod endpoint on failure
    return "https://tags.tiqcdn.com/utag/bofa/main/prod/utag.sync.js";
  }
}

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.sales.modules/mbox-module",
  "version": "1.0.0",
  "id": "mboxModule",
  "containerID": "salesMboxModule",
  "moduleName": "sales-mbox-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "mbox-module",
  "data": {
    "init": "mboxModuleJS",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        mboxScript
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    mboxScript
  },
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0"
  },
  "stores": []
};

// this file was created by default via Transmogrify
class mboxModuleJS extends Module {
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }
  init() {}
}
registerModuleClass({
  moduleClass: mboxModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { mboxModuleJS as default, moduleConfig };
